import { FaqSection } from "@/components/sections/section-faq";

export default function FaqPage() {
  return (
    <div>
      <FaqSection />
    </div>
  );
}
